import { styled, createGlobalStyle } from 'styled-components';
import { bp } from './breakPoints.tsx';

export const GlobalStyles = createGlobalStyle`

:root {
  --Lime: #C0E300;
  --b2b-Lime: #E6F499;
  --Ametisti: #96008F;
  --Ametisti-Light: #B000A8;
  --Lumme: #004107;
  --Vesi: #A3E4E8;
  --Laventeli: #E0CCFF;
  --Valkoinen: #ffffff;
  --Vaaleanharmaa-light: #F2F2F2;
  --Punainen: #C52009;
  --Harmaa: #898989;
  --Valo: #F6F9FB;
  --Varjo: #1D1D1D;
  --Disabled: #6E7071;
  --font-family: covik-sans-mono, sans-serif;
}

html {
  font-size: 62.5%;
  text-size-adjust: 100%;
}

body {
  box-sizing: border-box;
  font-family: var(--font-family);
  font-size: 1.6rem;
  line-height: 1.5;
  color: #333;
  background-color: var(--Valo);
  margin: 0;
}

a {
  color: var(--Lumme);
}

h1, h2, h3 {
  font-family: itc-benguiat,serif;
}

h2 {
  font-size: 2rem;

  @media ${bp.md} {
    font-size: 2.6rem;
  }
}
h3 {
  font-size: 2rem;
}

button {
  display: inline-block;
  padding: 12px 32px;
  border-radius: 50px;
  border: 2px solid var(--Ametisti);
  color: var(--Ametisti);
  background: var(--Valkoinen);
  font-family: var(--font-family);
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  font-size: 1.6rem;
  text-align: center;
  text-decoration: none;
  cursor: pointer;

  &:hover:not(:disabled):not(.disabled) {
    opacity: 0.8;
  }

  &:disabled:not(.lumme-button), &.disabled:not(.lumme-button) {
    background: var(--Disabled) !important;
    border: 2px solid var(--Disabled) !important;
    color: var(--Valkoinen) !important;

    &:hover {
      cursor: not-allowed;
    }
  }

  &.primary {
    background: var(--Lumme);
    color: var(--Valkoinen);
    border: 2px solid var(--Lumme);

    &.purple {
      background: var(--Ametisti);
      color: var(--Valkoinen);
      border: 2px solid var(--Ametisti);
    }
  }

  &.link-button {
    border: none;
    text-decoration: underline;
    color: var(--Lumme);
    padding: 0;
    font-size: 14px;
    background: transparent;

    &.black {
      color: var(--Varjo);
    }
  }

  &.green {
    color: var(--Lumme);
    border-color: var(--Lumme);
  }
}

input[type='radio'] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  background-color: var(--Valkoinen);
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: var(--Lumme);
  width: 30px;
  height: 30px;
  border: 2px solid var(--Lumme);
  border-radius: 50%;
  transform: translateY(-0.075em);

  display: grid;
  place-content: center;
}

input[type="radio"]::before {
  content: "";
  width: 20px;
  height: 20px;
  border-radius: 50%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--Lumme);
}

input[type="radio"]:checked::before {
  transform: scale(1);
}

  // Icon for only checkbox
  input[type="checkbox"] {
    box-sizing: border-box;
    width: 30px;
    height: 30px;
    margin: 6px 0;
    padding: 0;
    border: 2px solid var(--Lumme);
    appearance: none;
    background-color: transparent;
    outline: none;
    transition: outline 0.1s;
    border-radius: 4px;
  }
  input[type="checkbox"]:checked {
    background-size: cover;
    padding: 2px;
  }

  input[type="checkbox"]:not(:disabled):checked {
    border-color: var(--checkbox-checked-color);
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 32 32" xml:space="preserve"><path style="fill: %23004107" d="M11.941,28.877l-11.941-11.942l5.695-5.696l6.246,6.246l14.364-14.364L32,8.818"/></svg>');
  }

  input[type="checkbox"]:active {
    outline: 2px solid var(--Lumme);
  }
  input[type="checkbox"]:focus {
    outline: 2px solid var(--Lumme);  
  }

  label {
    font-weight: 600;
    color: #004107;
    line-height: 2;
    cursor: pointer;

    input {
      &[type='text'],
      &[type='number'],
      &[type='email'],
      &[type='tel'],
      &[type='date'] {
        display: block;
      }
    }

    &.checkbox-label {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .with-suffix {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .description {
      color: #000;
      font-size: 1.6rem;
      font-weight: 500;
      padding: 0;
      max-width: calc(100% - 50px);
    }

    p {
      color: #000;
      font-weight: 400;
      margin-top: 0;
      line-height: 20px;
    }
  }

  input {
    font-size: 16px;
    cursor: pointer;

    &[type='text'],
    &[type='number'],
    &[type='email'],
    &[type='tel'],
    &[type='date'] {
      padding: 1rem;
      border-radius: 0.4rem;
      background-color: #fff;
      border: solid 2px #004107;
      color: var(--Varjo);

      &::placeholder {
        color: #bcbcbc;
      }

      &:active,
      &:focus,
      &:focus-visible {
        border: 2px solid var(--Lime);
        outline: 0;
      }

      &.invalid {
        border: 2px solid var(--Punainen);
      }

      &:disabled {
        background: #f2f2f2;
        color: #898989;
        cursor: not-allowed;
      }
    }
  }

  select {
    font-size: 16px;
    padding: 1rem;
    border-radius: 0.4rem;
    background-color: #fff;
    border: solid 2px #004107;
    color: var(--Varjo);
    cursor: pointer;

    &.invalid {
      border: 2px solid var(--Punainen);
    }

  }

  p a {
    color: var(--Lumme);
    font-weight: 700;
  }

  span.invalid {
    color: var(--Punainen);
    font-size: 1.4rem;
    font-weight: 700;
  }

  .overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .alert-icon {
    position: absolute;
    top: -32px;
    right: 28px;
    height: 24px;
    width: 24px;
    background-color: var(--Punainen);
    border-radius: 4px 4px 0 0;
    padding: 4px;
  }

  .custom-date-picker {

    h2.react-datepicker__current-month {
      font-size: initial;
      margin-bottom: 6px;
    }

    .react-datepicker__day--selected {
      background-color: var(--Lime) !important;
    }

    .react-datepicker {
      font-size: 1em;

      button:hover {
        border: none;
        color: none;
      }
    }
    .react-datepicker__header {
      padding-top: 0.8em;
    }
    .react-datepicker__month {
      margin: 0.4em 1em;
    }
    .react-datepicker__day-name, .react-datepicker__day {
      width: 1.9em;
      line-height: 1.9em;
      margin: 0.166em;
    }
    .react-datepicker__current-month {
      font-size: 1em;
    }
    .react-datepicker__navigation {
      top: 1em;
      line-height: 1.7em;
      border: 0.45em solid transparent;
    }
    .react-datepicker__navigation--previous {
      left: 1em;
    }
    .react-datepicker__navigation--next {
      right: 1em;
    }
    .react-datepicker__navigation {
      border: none;
    }
    .react-datepicker__day--keyboard-selected {
      background-color: transparent;
      &:hover {
        background-color: var(--Lime);
      }
    }

    .react-datepicker__day:hover {
      background-color: var(--Lime);
    }
  }

.lumme-button {
  background: var(--Pvrit-Valkoinen, #fff);
  border: 2px solid var(--Pvrit-Ametisti, #96008f);
  border-radius: 50px;
  color: var(--Pvrit-Ametisti, #96008f);
  cursor: pointer;
  display: inline-block;
  font-family: covik-sans-mono, sans-serif;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  padding: 12px 32px;
  text-align: center;
  text-decoration: none;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 16px;

  svg {
    fill: var(--Pvrit-Ametisti, #96008f);
  }

  a {
    text-decoration: none;
    color: inherit;
  }
}

.lumme-button.primary {
  background: var(--Pvrit-Ametisti, #96008f);
  color: var(--Pvrit-Valkoinen, #fff);
  border: 2px solid var(--Pvrit-Ametisti, #96008f);

  svg {
    fill: var(--Pvrit-Valkoinen, #fff);
  }

}

.lumme-button.primary:hover:enabled {
  background: var(--Pvrit-Valkoinen, #fff);
  color: var(--Pvrit-Ametisti, #96008f);
  border: 2px solid var(--Pvrit-Ametisti, #96008f);

  svg {
    fill: var(--Pvrit-Ametisti, #96008f);
  }
}

.lumme-button.secondary {
  background: transparent;
  color: var(--Pvrit-Lumme, #004107);
  border: 2px solid var(--Pvrit-Lumme, #004107);

  svg {
    fill: var(--Pvrit-Lumme, #004107);
  }
}

.lumme-button.secondary:hover:enabled {
  background: var(--Pvrit-Lumme, #004107);
  color: var(--Pvrit-Valkoinen, #fff);
  border: 2px solid var(--Pvrit-Lumme, #004107);

  svg {
    fill: var(--Pvrit-Valkoinen, #fff);
  }
}

.lumme-button.secondary.white {
  background: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;

  svg {
    fill: #ffffff;
  }
}

.lumme-button.secondary.white:hover:enabled {
  background: #ffffff;
  color: var(--Pvrit-Lumme, #004107);
  border: 2px solid #ffffff;

  svg {
    fill: var(--Pvrit-Lumme, #004107);
  }
}

.lumme-button.lime {
  background: var(--Tukivrit-Lime, #C0E300);
  color: var(--Pvrit-Lumme, #004107);
  border: 2px solid var(--Tukivrit-Lime, #C0E300);

  svg {
    fill: var(--Pvrit-Lumme, #004107);
  }
}
.lumme-button.lime:hover:enabled {
  background: var(--Pvrit-Lumme, #004107);
  color: var(--Tukivrit-Lime, #C0E300);
  border: 2px solid var(--Tukivrit-Lime, #C0E300);

  svg {
    fill: var(--Tukivrit-Lime, #C0E300);
  }
}

.lumme-button.lumme {
  background: var(--Pvrit-Lumme, #004107);
  color: var(--Pvrit-Valkoinen, #fff);
  border: 2px solid var(--Pvrit-Lumme, #004107);

  svg {
    fill: var(--Pvrit-Valkoinen, #fff);
  }
}

.lumme-button.lumme:hover:enabled {
  background: var(--Pvrit-Valkoinen, #fff);
  color: var(--Pvrit-Lumme, #004107);
  border: 2px solid var(--Pvrit-Lumme, #004107);

  svg {
    fill: var(--Pvrit-Lumme, #004107);
  }
}

.lumme-button:disabled {
  background: var(--Disabled, #6E7071);
  color: var(--Valkoinen, #fff);
  border: 2px solid var(--Disabled, #6E7071);

  svg {
    fill: var(--Valkoinen, #fff);;
  }
}

`;

export const Content = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 0;

  @media ${bp.md} {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
  }
`;

export const WhiteContainer = styled.div`
  background-color: white;
  box-shadow: 0 8px 24px hsla(210,8%,62%,.2);
  border-radius: 4px;
  padding: 20px;
  margin: 0 10px;
  border: solid 2px transparent;

  &.error {
    border-color: var(--Punainen);
  }

  @media ${bp.md} {
    padding: 36px;
    margin: 0 16px;
  }

  h2 {
    color: var(--Lumme);
    font-size: 2rem;
    font-weight: 700;
    margin: 0 0 8px;

    @media ${bp.md} {
      font-size: 2.6rem;
      margin: 0 0 16px;
    }
  }

  .actions {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    gap: 20px;
  }

  .info {
    display: flex;
    gap: 10px;
  }
`;

export const RadioButtons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  @media ${bp.md} {
    grid-template-columns: repeat(4, 1fr);
  }

  .radio-label {
    text-align: center;
    position: relative;

    input[type='radio'] {
      position: absolute;
      height: 20px;
      width: 20px;
      top: 12px;
      right: 12px;
      border: none;
      background-color: transparent;
    }

    input[type='radio']::before {
      background: center url('https://www.lumme-energia.fi/hubfs/B2C-S%C3%A4hk%C3%B6-Ostoputki/check-icon.svg') var(--Lumme);
      background-repeat: no-repeat;
      box-shadow: none;
    }


    input[type='radio']:checked + .image-container {
      background-color: var(--Lime);
    }
    
  }

  .text {
    font-weight: 400;
  }

  .radio-label .image-container {
    background-color: var(--Valo);
    border-radius: 4px;
    height: auto;
    margin-bottom: 16px;
    padding: 30px 20px;
    display: flex;
    justify-content: center;
    gap: 4px;
    border-radius: 4px;

    &.big-icon {
      padding: 10px 10px 0 10px;
      display: table;
      height: 90px;
      width: calc(100% - 20px);

      img {
        height: 80px;
      }
    }

    img {
      height: 32px;

      @media ${bp.sm} {
        height: 45px;
      }
    }
  }

  a {
    text-decoration: none;
    width: 100%;
  }

  button.option-button {
    width: 100%;
    border: none;
    padding: 0;
    color: var(--Lumme);
    position: relative;
    border-radius: 0;
    display: flex;
    flex-direction: column;

    &:hover {
      opacity: 1;
    }

    .image-container {
      background-color: var(--Valo);
      border-radius: 4px;
      height: auto;
      margin-bottom: 16px;
      padding: 30px 20px;
      display: flex;
      justify-content: center;
      gap: 4px;

      &.big-icon {
        padding: 10px 10px 0 10px;
        display: table;
        height: 90px;

        img {
          height: 80px;
        }
      }

      img {
        height: 32px;

        @media ${bp.sm} {
          height: 45px;
        }
      }
    }

    &.selected .image-container {
      background-color: var(--Lime);
      color: var(--Valkoinen);
      border-radius: 4px;

      &::after {
        content: '';
        background: center url('https://www.lumme-energia.fi/hubfs/B2C-S%C3%A4hk%C3%B6-Ostoputki/check-icon.svg') var(--Lumme);
        height: 20px;
        width: 20px;
        display: block;
        position: absolute;
        top: 12px;
        right: 12px;
        border-radius: 50px;
        background-repeat: no-repeat;
      }
    }

    .business-type {
      font-weight: 500;
      line-height: 2;
    }
  }
`;



export const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 20px;
`;

export const ProductsList = styled.div`
  overflow: auto;

  .products {

    display: flex;
    gap: 10px;
    padding: 20px 0;

    @media ${bp.md} {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;

export const Recommendation = styled.div`
  padding: 0 20px;
`;


export const AdditionalServicesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .additional-service {
    background: var(--Valkoinen);
    border: 2px solid var(--Valkoinen);
    border-radius: 8px;
    color: var(--Varjo);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 2.2rem 1.6rem;
    position: relative;
    align-items: stretch;

    &.sekasahko {
      background: #E9ECEE;
    }

    &:has(input:checked) {
      border-color: var(--Lumme);
    }

    .header {
      align-items: center;
      display: flex;
      flex-direction: row;
      gap: 1.2rem;
      justify-content: flex-start;
      margin-bottom: 8px;

      .title {
        font-family: itc-benguiat,serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-bottom: 0;

        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;

        .title-label {
          font-family: covik-sans-mono, sans-serif;
          font-size: 16px;
        }
      }

    }

    .description {
      font-weight: 400;
      line-height: 1.5;
      margin-bottom: 10px;

      ul, p {
        margin: 0;
        line-height: 1.5;
      }
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;

      .image {
        position: absolute;
        right: 10px;
        top: -10px;
      }
    }

    .price {
      font-family: itc-benguiat,serif;
      font-size: 20px;
      font-weight: 700;
      line-height: normal;
    }

    /* input {
      appearance: none;
    } */

    .label {
      background: var(--Lumme);
      border-radius: 48px;
      font-size: 16px;
      color: var(--Valkoinen);
      padding: 6px 16px;
    }
  }
`;

export const ContentContainer = styled.div`
  padding: 0 16px;

  .center {
    text-align: center;
    margin-bottom: 0;

    &.error {
      color: var(--Punainen);
    }
  }

  > h2, h3 {
    margin: 0;

    @media ${bp.md} {
      margin: 20px 0;
    }
  }
`;

export const Grid = styled.div`
  display: grid;
  gap: 20px;

  @media ${bp.md} {
    grid-template-columns: repeat(2, 1fr);
  }

  input[type='text'],
  input[type='number'],
  input[type='email'],
  input[type='tel'],
  input[type='date']{
    width: 100%;
    box-sizing: border-box;
  }
`;

export const ProductSummary = styled.div`
  display: flex;
  flex-direction: column;

  &.b2b {
    gap: 10px;

    .title {
      color: var(--Lumme);
    }
  }

  .card-title {
    font-size: 20px;
    font-weight: 600;
  }

  .title {
    color: var(--Ametisti);
    font-weight: 700;

    &.border {
      border-top: 3px solid var(--Ametisti);
      padding-top: 2rem;
      margin-top: 2rem;
    }
  }

  .price-row {
    display: flex;
    gap: 20px;

    .text {
      width: 160px;
    }
  }

  ul {
    margin: 0;
    padding-inline-start: 30px;
  }

  .summary-label {
    display: flex;
    padding: 8px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    background-color: var(--Lime);
    border-radius: 8px;
    box-shadow: 0px 1px 24px 8px rgba(20, 20, 20, 0.08);
    margin-top: 20px;

    @media ${bp.md} {
      align-self: flex-start;
      padding: 8px 16px;
    }

    &.discount {
      margin-bottom: 20px;
      margin-top: 0;
      width: calc(100% - 16px);
      padding: 8px;
    }
  }

  .description {
    padding: 10px 0;
  }

  .summary-description {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

export const SummaryLabels = styled.div`

  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
  border: solid transparent 2px;
  border-radius: 4px;

  &.invalid {
    border: solid var(--Punainen) 2px;
  }

  .terms-label {
    padding: 5px 0 0 5px;
    border: solid transparent 2px;

    &.invalid {
      border-color: var(--Punainen);
    }
  }

  label {
    display: flex;
    padding: 0;
    border-radius: 4px;

    &.border {
      padding: 16px;
      border: 2px solid var(--Lumme);
    }
  }

  .einvoice {
    flex-direction: column;

    @media ${bp.sm} {
      gap: 10px;
      align-items: center;
      flex-direction: row;
    }
  }

  .b2b-invoice {
    flex-direction: column;

    p {
      margin: 0;
      color: #000;
      line-height: normal;
      font-weight: 500;
      margin-bottom: 6px;
    }
  }

  .radio-label {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .header {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &.row {
      .description {
        width: 100%;
      }
    }
  }


`;



export const LoadingSpinner = styled.div`

  width: 48px;
  height: 48px;
  border: 5px solid var(--Lumme);
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;


@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`;

interface DashLineProps {
  direction?: 'vertical' | 'horizontal'
}

export const DashLine = styled.div<DashLineProps>`
  margin: ${props => props.direction == 'vertical' ? '0 20px' : '20px 0'};
`;
